import React from 'react';
import { AppTable, AppRow, AppButton, AppGridBar, AppGridTabs, AppGridLayout } from 'qcc';
import { AppFormLayout } from 'qcc';
import { AppAction } from 'qcc';
import api from 'api';

export default class extends React.Component<{ mode?: number, id?: number, selectedProject: any[], selectedOrgan: any[]  }> {
  state = { changFlag: false, tabIndex: 0}


  handle = () => {
    let selected = this.refTable.current.getSelected();
    console.log('selected', selected)
    this.authorizeUser(selected, this.props.id, this.state.tabIndex);
  }

  authorizeUser = async (dataList?: any[], id?: number, type?: number) => {
    let mode = 'authorizeUser';
    switch (type) {
      case 0:
        let organList = dataList.map((data: any) => {
          return data.id as number;
        })

        await api.apporgan.authorize({ mode, list: organList, id })
        break;
      case 1:
      mode = 'authorizeUserProject';
        let projectList = dataList.filter(e => e.dataType === 'xm').map((data: any) => {
          return data.id as number;
        })
        await api.mdmproject.authorize({ mode, list: projectList, id })
        break;
      case 2:
      mode = 'authorizeUserStage';
        let stageList = dataList.filter(e => e.dataType === 'fq').map((data: any) => {
          return data.id as number;
        })
        await api.mdmproject.authorize({ mode, list: stageList, id })
        break;
      default:
        break;
    }

    AppAction.successMsg('授权成功！');
  }

  befTabChg = () => {
    if (this.state.changFlag && !confirm('请确定当前页面授权是否已经保存！')) {
      return false
    }
    return true
  }

  tabChg = async (tabIndex: number) => {


    this.setState({ tabIndex, changFlag: false });
  }

  close = () => {
    if (this.props.mode === 2) {
      AppAction.closeDrawer();
      return;
    }

    AppAction.closeDialog();
  }

  renderTable = () => {
    let { tabIndex } = this.state
    let {  selectedOrgan, selectedProject } = this.props
    switch (tabIndex) {
      case 0:
        return <AppTable ref={this.refTable} parentKeyName='parent_id' sqlId='sql.organ.gridTree' paging={false} orderBy='full_code' selected={selectedOrgan || []} 
        >
          <AppTable.ColCheckbox />
          <AppTable.Col title='公司' field='name' />
        </AppTable>
      case 1:
        return <AppTable ref={this.refTable} parentKeyName='parent_id' sqlId='sql.mdmProject.gridXmTree' paging={false} orderBy='full_code' selected={selectedProject || []} >
          <AppTable.ColCheckbox />
          <AppTable.Col title='公司/项目' field='name' expand />
        </AppTable>
      case 2:
        return <AppTable ref={this.refTable} parentKeyName='parent_id' sqlId='sql.mdmProject.gridTree' paging={false} orderBy='full_code' selected={selectedProject || []} >
          <AppTable.ColCheckbox />
          <AppTable.Col title='公司/项目/分期' field='name' expand />
        </AppTable>
      default:
        return <AppTable ref={this.refTable} parentKeyName='parent_id' sqlId='sql.organ.gridTree' paging={false} orderBy='full_code' selected={selectedOrgan || []} >
          <AppTable.ColCheckbox />
          <AppTable.Col title='公司' field='name'  />
        </AppTable>
    }
  }

  refTable = React.createRef<AppTable>();
  refGrid = React.createRef<AppGridLayout>();
  render() {
    return (
      <AppGridLayout ref={this.refGrid} key={this.state.tabIndex}>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Left>
              <AppGridTabs defaultTabIndex={this.state.tabIndex} tabs={['公司', '项目', '分期']} befChange={this.befTabChg} onChange={this.tabChg} />
            </AppGridBar.Left>
            <AppGridBar.Right>
              <AppButton label="确定" actionCode="00010206" type='primary' action={this.handle} />
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          {this.renderTable()}
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/page/public/MdmProjectSearchor.tsx